// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.em-grid-cell {
    fill: #ffffff;
    stroke-linecap: round;
    stroke-linejoin: round;
    cursor: pointer !important;
}

.em--coxcomb .em-grid-cell,
.em--spark .em-grid-cell {
    /* fill: navajowhite; */
    fill: #fce8cc;
}

.em--ch .em-grid-cell,
.em--scomp .em-grid-cell {
    fill: #eeeeee;
}
.em-grid-text {
    opacity: 0.75;
}
.em-grid-hexagon {
    /* opacity: 0.7; */
}

.em--coxcomb .em-grid-shape,
.em--pie .em-grid-shape {
    fill: none;
    stroke: #ccc !important;
    stroke-width: 0px;
}

/* .em--coxcomb .em-grid-text,
.em--pie .em-grid-text {
    transform: translate(0, -22px) !important;
} */
`, "",{"version":3,"sources":["webpack://./src/css/cartogram.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,qBAAqB;IACrB,sBAAsB;IACtB,0BAA0B;AAC9B;;AAEA;;IAEI,uBAAuB;IACvB,aAAa;AACjB;;AAEA;;IAEI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;AACA;IACI,kBAAkB;AACtB;;AAEA;;IAEI,UAAU;IACV,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;;;GAGG","sourcesContent":[".em-grid-cell {\r\n    fill: #ffffff;\r\n    stroke-linecap: round;\r\n    stroke-linejoin: round;\r\n    cursor: pointer !important;\r\n}\r\n\r\n.em--coxcomb .em-grid-cell,\r\n.em--spark .em-grid-cell {\r\n    /* fill: navajowhite; */\r\n    fill: #fce8cc;\r\n}\r\n\r\n.em--ch .em-grid-cell,\r\n.em--scomp .em-grid-cell {\r\n    fill: #eeeeee;\r\n}\r\n.em-grid-text {\r\n    opacity: 0.75;\r\n}\r\n.em-grid-hexagon {\r\n    /* opacity: 0.7; */\r\n}\r\n\r\n.em--coxcomb .em-grid-shape,\r\n.em--pie .em-grid-shape {\r\n    fill: none;\r\n    stroke: #ccc !important;\r\n    stroke-width: 0px;\r\n}\r\n\r\n/* .em--coxcomb .em-grid-text,\r\n.em--pie .em-grid-text {\r\n    transform: translate(0, -22px) !important;\r\n} */\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
